import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { ADVERTISEMENTS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateAdvertisementProductsAction = createAsyncThunk(
    'pod/updateAdvertisementProductsAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ ADVERTISEMENTS_PATH }/${ data.id }/products`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateAdvertisementProductsSlice = createSlice({
    name: 'updateAdvertisementProductsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateAdvertisementProductsAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateAdvertisementProductsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateAdvertisementProductsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateAdvertisementProductsState = (state) => state.pod.updateAdvertisementProducts;
export default updateAdvertisementProductsSlice.reducer;